export function ProcessMQTTMessages(topic,message) {
  console.log(message);
  let mess = b64DecodeUnicode(message);//信息需要进行解码处理
  // 截取掉最后一个
  console.log("最后一个字符值是：",mess.substring(mess.length-1));
  if(mess.substring(mess.length-1) !== "}"){
    mess = mess.substring(0,mess.length-1)
  }
  console.log(mess.substring(mess.length-1) == "}");
  let data = mess;
  console.log(data);
  alert("---------------消息主题："+topic+"，消息内容："+data);
  if(isJSON(data)){
    let jsonObject = JSON.parse(data)
    console.log(jsonObject)
  }

  /*let test = '{"mess":"helloword"}';
  let encTest = b64EncodeUnicode(test);
  let mess = b64DecodeUnicode(encTest);
  if(mess.substring(mess.length-1) !== "}"){
    mess = mess.substring(0,mess.length-1)
  }
  console.log(JSON.parse(mess))*/
}

//base64加密  发信息
function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match,p1){
      return String.fromCharCode('0x'+p1);
    }));
}

//base64解密
function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).split('').map(function(c){
    return '%'+('00'+c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

function isJSON(str) {
  if (typeof str == 'string') {
    try {
      let obj=JSON.parse(str);
      if(typeof obj == 'object' && obj ){
        return true;
      }else{
        return false;
      }

    } catch(e) {
      console.log('error：'+str+'!!!'+e);
      return false;
    }
  }
  console.log('It is not a string!')
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/mqtt.js